var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo photo-component",style:({
  '--position':_vm.photo.position
})},[_c('img',{attrs:{"src":_vm.photo.src,"alt":_vm.photo.url}}),_c('legende-deco',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.photo.legende.val)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }